var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollibra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.26,
    height: 26,
    viewBox: "0 0 26.26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0.964 0.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1757",
    "data-name": "Ellipse 1757",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(10.848 -0.478) rotate(-13.28)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1758",
    "data-name": "Ellipse 1758",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(10.846 23.012) rotate(-13.28)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1759",
    "data-name": "Ellipse 1759",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(18.896 3.768) rotate(-45)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1760",
    "data-name": "Ellipse 1760",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(19.114 19.552) rotate(-13.28)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1761",
    "data-name": "Ellipse 1761",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(2.284 20.326) rotate(-45)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1762",
    "data-name": "Ellipse 1762",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(-0.964 11.284) rotate(-13.28)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1763",
    "data-name": "Ellipse 1763",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(22.349 12.061) rotate(-45)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1764",
    "data-name": "Ellipse 1764",
    cx: 1.043,
    cy: 1.043,
    r: 1.043,
    transform: "translate(2.285 3.739) rotate(-45)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59397",
    "data-name": "Path 59397",
    d: "M65.853,25.15A1.043,1.043,0,0,0,64.81,26.2V30.35h0v.015a1.043,1.043,0,1,0,2.086,0v-.028h0V26.182A1.043,1.043,0,0,0,65.853,25.15Z",
    transform: "translate(-53.75 -22.428)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59398",
    "data-name": "Path 59398",
    d: "M65.853,82.4a1.041,1.041,0,0,0-1.043,1.043V87.6h0v.028a1.043,1.043,0,1,0,2.086,0V87.6h0V83.443A1.041,1.041,0,0,0,65.853,82.4Z",
    transform: "translate(-53.75 -67.26)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59399",
    "data-name": "Path 59399",
    d: "M33.962,63.32H27.7a1.043,1.043,0,1,0,0,2.086h6.259a1.043,1.043,0,1,0,0-2.086Z",
    transform: "translate(-23.942 -52.302)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59400",
    "data-name": "Path 59400",
    d: "M81.662,65.406a1.043,1.043,0,1,0,0-2.086H75.4a1.043,1.043,0,1,0,0,2.086Z",
    transform: "translate(-61.211 -52.302)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59401",
    "data-name": "Path 59401",
    d: "M84.931,21.513a1.041,1.041,0,0,0,1.043-1.045v-.028h0V13.574a1.045,1.045,0,1,0-2.088,0v6.866h0v.028a1.043,1.043,0,0,0,1.045,1.043Z",
    transform: "translate(-68.654 -12.529)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59402",
    "data-name": "Path 59402",
    d: "M46.649,82.4a1.041,1.041,0,0,0-1.043,1.043v6.869h0v.026a1.045,1.045,0,1,0,2.088,0v-.026h0V83.443A1.043,1.043,0,0,0,46.649,82.4Z",
    transform: "translate(-38.745 -67.26)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59403",
    "data-name": "Path 59403",
    d: "M15.094,46.194h6.891a1.045,1.045,0,0,0,0-2.088H15.094a1.045,1.045,0,1,0,0,2.088Z",
    transform: "translate(-14.052 -37.271)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59404",
    "data-name": "Path 59404",
    d: "M91.838,82.4H84.943a1.043,1.043,0,1,0,0,2.086h6.895a1.043,1.043,0,1,0,0-2.086Z",
    transform: "translate(-67.956 -67.227)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59405",
    "data-name": "Path 59405",
    d: "M46.771,17.34A1.041,1.041,0,0,0,47.814,16.3v-.028h0V13.574a1.045,1.045,0,1,0-2.088,0v2.694h0V16.3a1.043,1.043,0,0,0,1.045,1.043Z",
    transform: "translate(-38.838 -12.529)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59406",
    "data-name": "Path 59406",
    d: "M17.811,84.474a1.045,1.045,0,0,0,0-2.088H15.095a1.045,1.045,0,1,0,0,2.088Z",
    transform: "translate(-14.052 -67.215)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59407",
    "data-name": "Path 59407",
    d: "M104.023,46.326h2.723a1.043,1.043,0,0,0,0-2.086h-2.723a1.043,1.043,0,1,0,0,2.086Z",
    transform: "translate(-83.656 -37.376)",
    fill: "#72bf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59408",
    "data-name": "Path 59408",
    d: "M84.935,101.35a1.045,1.045,0,0,0-1.045,1.043v.028h0v2.7a1.045,1.045,0,0,0,2.088,0v-2.7h0v-.028A1.043,1.043,0,0,0,84.935,101.35Z",
    transform: "translate(-68.657 -82.066)",
    fill: "#72bf00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollibra);
export default __webpack_public_path__ + "static/media/collibra.e566e60e9a5a50918c079e5a9d791091.svg";
export { ForwardRef as ReactComponent };